import { autoinject, computedFrom, observable, BindingEngine } from 'aurelia-framework';
import { BaseDevice } from "./base-device";
import { Device } from "../../../models/device";
import { Api } from "../../../services/api";
import { I18N } from "aurelia-i18n";
import { DigitalOutputToggleRequestViewModel } from "../../../models/digital-output-toggle-request-view-model";
import { Store } from "aurelia-store";
import { IState } from "../../../store/state";
import { ValveState } from "./valve-state-enum";
@autoinject
export class StregaSmartValve extends BaseDevice {

	api: Api;

	disabled: boolean = false;
	pending: boolean = false;
	suppressApiCall: boolean = false;
	message: string;
	buttonText: string;
	css: string;
	pendingCss: string;

	constructor(store: Store<IState>, api: Api, private i18n: I18N) {
		super(store, api);

		this.disabled = true;
		this.buttonText = this.i18n.tr("offline");
	}

	@computedFrom('device.data')
	get checked(): string {

		if (!this.device ||
			this.device.data === undefined ||
			this.device.data.valveIsOpen === undefined) {
			return null;
		}

		if (this.pending) {
			this.pendingCss = "";
			this.pending = false;
			this.disabled = false;
		}
		this.buttonText = this.device.data.valveIsOpen ? "Close" : "Open";

		return this.device.data.valveIsOpen;
	}


	setChecked(valveState: ValveState) {

		this.suppressApiCall = true;
		this.pending = false;
		this.message = "";
		this.css = "";
		this.pendingCss = "";

		setTimeout(() => { this.disabled = false; }, (15 * 1000));

		switch (valveState) {
			case ValveState.Closed:
				this.buttonText = "Open";
				break;
			case ValveState.Open:
				this.buttonText = "Close";
				break;
			case ValveState.Pending:
				this.buttonText = "Pending...";
				break;
		}
	}

	activate(device: Device) {
		this.device = device;
		this.subscription = this.store.state.subscribe((state) => {
			this.applicationState = state;

			if (!this.pending) {
				const newDevice = this.getDevice();
				if (newDevice && newDevice.data) {

					if (this.device.data.valveIsOpen != newDevice.data.valveIsOpen) {
						this.device.data = newDevice.data;
					}
					
				}
			}
			
		});

		this.setChecked((this.device && this.device.data) ? (this.device.data.valveIsOpen ? ValveState.Open : ValveState.Closed) : ValveState.Pending);

	}

	async toggleChecked() {

		if (this.device) {
			const viewModel = new DigitalOutputToggleRequestViewModel();
			viewModel.deviceIds.push(this.device.deviceId);
			viewModel.state = !this.checked;
			this.pending = true;
			this.message = "pending";
			this.buttonText = "Pending...";
			this.pendingCss = "mdi mdi-24px mdi-spin mdi-refresh";
			this.disabled = true;
			const response = await this.api.toggleValve(viewModel);
			if (response.success === false) {
				this.pending = false;
				this.message = response.message;
				this.disabled = false;
				this.buttonText = this.device.data.valveIsOpen ? "Close" : "Open";
			}

		}
	}
}